import './accordionComponent.scss';
import React, {useCallback, useEffect} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {CommonService} from "../../services";
import ChipComponent from "../chip/ChipComponent";

interface AccordionComponentProps {
    title?: React.ReactNode | string;
    subTitle?: string;
    actions?: React.ReactNode;
    isExpanded?: boolean;
    onChange?: (isExpanded: boolean) => void;
    disabled?: any;
    disableExpanding?: boolean;
    forActivityLog?: boolean;
    name?: string;
    statusLabel?: string;
}

const AccordionComponent = (props: React.PropsWithChildren<AccordionComponentProps>) => {

        const {title,statusLabel,name, subTitle,forActivityLog, actions, children, onChange, disabled} = props;
        let {disableExpanding} = props;
        if (!disableExpanding) {
            disableExpanding = false;
        }
        const [isExpanded, setIsExpanded] = React.useState<any>(props.isExpanded);

        const handleChange = useCallback((isExpanded: any) => {
            setIsExpanded(isExpanded);
            if (onChange) {
                onChange(isExpanded);
            }
        }, [onChange]);

        useEffect(() => {
            setIsExpanded(props.isExpanded);
        }, [props.isExpanded]);

        return (
            <div className="accordion-wrapper">
                <Accordion
                    disabled={disabled}
                    expanded={isExpanded}
                    onChange={(e, isExpanded) => {
                        if (disableExpanding) {
                            e.stopPropagation()
                        } else {
                            handleChange(isExpanded)
                        }
                    }
                    }>
                    <AccordionSummary
                        expandIcon={!disableExpanding ? <ExpandMoreIcon/> :
                            <span className={'MuiAccordionSummary-expandIconWrapper'}></span>}
                        className={"accordion-summary" + (disableExpanding ? " disable-expanding" : "")}
                    >
                        <div className={"accordion-header"} onClick={(e: any) => disableExpanding && e.stopPropagation()}>
                            <div className="accordian-tile">
                                {title && (!forActivityLog ? title : (typeof title === "string" ? CommonService.capitalizeFirstLetterOfEachWord(title): title))}
                                <span className="accordian-sub-tile">
                                    {subTitle}
                                </span>
                                {
                                    name && <span className="accordian-user-name">
                                        {CommonService.capitalizeFirstLetterOfEachWord(name)}
                                    </span>
                                }

                            </div>
                            {statusLabel && <div className="accordian-status">
                                <ChipComponent
                                    label={statusLabel}/>
                            </div>}

                        </div>
                        <div className="accordian-actions"
                             onClick={(e) => e.stopPropagation()}>
                            {actions}
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        {children}
                    </AccordionDetails>
                </Accordion>
            </div>
        )

    }

;

export default AccordionComponent;
